import { vaultPostRequest } from '../helpers';
import type { ICropBatchRequest } from './crop-batch-request';
import type { ICropBatchResponse } from './crop-batch-response';
import { cropBatchResponseSchema } from './crop-batch-response';

export async function cropBatchApi(body: ICropBatchRequest): Promise<ICropBatchResponse> {
  return vaultPostRequest({ path: '/crop/batch', body, schema: cropBatchResponseSchema });
}
